import { render, staticRenderFns } from "./UserExamTable.vue?vue&type=template&id=bcdce206&"
import script from "./UserExamTable.vue?vue&type=script&lang=ts&"
export * from "./UserExamTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports